import { Link } from "react-router-dom";
import { Header } from "@/header/header";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { AlertTriangle, TrendingUp, BarChart3, HelpCircle } from "lucide-react";

export const NotFound = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-destructive/10 mb-6">
              <AlertTriangle className="h-10 w-10 text-destructive" />
            </div>
            
            <h1 className="text-5xl font-bold mb-3">404</h1>
            <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
            
            <p className="text-muted-foreground mb-8">
              Looks like you've ventured into uncharted territory. 
              Let's get you back on track.
            </p>

            <Button asChild size="lg" className="mb-4">
              <Link to="/trade/BTC-USD">Return to Trading</Link>
            </Button>
          </div>

          <div className="border border-border rounded-lg p-6">
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <Link
                to="/account"
                className="flex items-center gap-2 p-3 border border-border rounded-lg hover:bg-accent transition-colors text-sm"
              >
                <BarChart3 className="h-4 w-4 text-primary flex-shrink-0" />
                <span>Account</span>
              </Link>
              <Link
                to="/trade/BTC-USD"
                className="flex items-center gap-2 p-3 border border-border rounded-lg hover:bg-accent transition-colors text-sm"
              >
                <TrendingUp className="h-4 w-4 text-primary flex-shrink-0" />
                <span>Markets</span>
              </Link>
              <a
                href={`${import.meta.env.VITE_SUPPORT_URL || '/support/'}contact`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 p-3 border border-border rounded-lg hover:bg-accent transition-colors text-sm"
              >
                <HelpCircle className="h-4 w-4 text-primary flex-shrink-0" />
                <span>Support</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <Toaster />
    </div>
  );
};

